import React, { Suspense, useState, useEffect } from 'react';

import Spinner from '../../components/Spinner/Spinner';

const FormBuilder = (props) => {
    const [isMounted, setIsMounted] = useState(false);
    const [baseUrl, setBaseUrl] = useState('');

    useEffect(() => {
        if (isMounted) {
            return;
        }

        let base_url = process.env.REACT_APP_SMART_DOC_WEB_BASE;
        if (process.env.REACT_APP_ENV === 'staging') {
            base_url = process.env.REACT_APP_SMART_DOC_WEB_STAGING;
        } else if (process.env.REACT_APP_ENV === 'test') {
            base_url = process.env.REACT_APP_SMART_DOC_WEB_TEST;
        } else if (process.env.REACT_APP_ENV === 'production') {
            base_url = process.env.REACT_APP_SMART_DOC_WEB_PRODUCTION;
        }
        setBaseUrl(base_url);
        setIsMounted(true);
    }, [isMounted, baseUrl]);

    return (
        <Suspense fallback={<Spinner text="Loading Form Builder..." />}>
            <div>
                <iframe id="doc-map-iframe" title="Form Builder"
                    style={{ width: '100%', height: 'Calc(100vh - 15px)' }}
                    src={`${baseUrl}/form-builder/${props.franchiseId}?sp=fm`}>
                </iframe>
            </div>
        </Suspense>
    )
}

export default FormBuilder;